import React from 'react';

export const Default=()=>{
    return (
        <div className="animated fadeIn">
            Task Plugins of Swarm Colony v0.29.1
        </div>
    )
}

export default Default;


// WEBPACK FOOTER //
// ./src/views/Default/Default.js